module.exports = __webpack_public_path__ + "media/images/career_camp/2023/areas_5-94995cd740a170046e9de7b65232ab48.png";